import React from "react";

export default function SectionTitle({ kicker, title, subtitle }) {
  return (
    <div className="mb-6">
      {kicker ? (
        <div className="text-xs uppercase tracking-widest text-indigo-300/80">
          {kicker}
        </div>
      ) : null}

      <h2 className="mt-2 text-2xl font-semibold text-white">{title}</h2>

      {subtitle ? (
        <p className="mt-2 max-w-2xl text-white/70">{subtitle}</p>
      ) : null}
    </div>
  );
}
